"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var mobx_react_1 = require("mobx-react");
var React = require("react");
var styles = require('./MessageAdListItem.scss');
var classNames = require('classnames/bind').bind(styles);
var FirstLineTextContainer = /** @class */ (function (_super) {
    tslib_1.__extends(FirstLineTextContainer, _super);
    function FirstLineTextContainer() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    FirstLineTextContainer.prototype.render = function () {
        var firstLineTextClasses = classNames(this.props.isReadingPanePositionOff && this.props.isUnread
            ? styles.firstLineTextUnread
            : styles.firstLineText, 'fbAdSubtitle', 'fbAdLink');
        return (React.createElement("div", { className: firstLineTextClasses },
            React.createElement("span", null, this.props.firstLineText)));
    };
    FirstLineTextContainer = tslib_1.__decorate([
        mobx_react_1.observer
    ], FirstLineTextContainer);
    return FirstLineTextContainer;
}(React.Component));
exports.default = FirstLineTextContainer;
//# sourceMappingURL=FirstLineTextContainer.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/mail/view/owa-mail-messagead-list-view/lib/components/FirstLineTextContainer.js
// module id = 3910
// module chunks = 67